import { FilterList, Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { AutocompleteDropdownConfig } from './filter-config';
import { I18n } from 'common/i18n';
import { changeTag } from 'common/components/AssetBrowser/actions/filters';
import { FilterType } from './types';
import { FilterScope, getScope } from './translations';
import { IBaseListDropdownOption } from '@tylertech/forge/esm/list-dropdown/list-dropdown-constants';
import { getFilteredOptions } from './filter-helper';

const scope = getScope(FilterScope.Tags);

const getTagOptions = (input: string, list: string[] = []): IBaseListDropdownOption<string | null>[] => {
  //  List type inferred from returned data.
  const allOptions = list.map((tag) => ({ label: tag, value: tag }));

  return getFilteredOptions(allOptions, input);
};

export const tagConfigs: AutocompleteDropdownConfig<string> = {
  filterName: Filters.Tag,
  label: I18n.t('label', { scope }),
  placeholder: I18n.t('placeholder', { scope }),
  filterCallback: getTagOptions,
  dispatchAction: changeTag,
  filterType: FilterType.AutocompleteDropdown,
  filterListName: FilterList.DomainTags,
};
